import { Component, input } from '@angular/core';
import {
  NgDiagramNodeSelectedDirective,
  NgDiagramBaseNodeTemplateComponent,
  NgDiagramPortComponent,
  type NgDiagramNodeTemplate,
  type Node,
} from 'ng-diagram';

type CustomDataType = {
  label: string;
};
@Component({
  standalone: true,
  imports: [NgDiagramPortComponent, NgDiagramBaseNodeTemplateComponent],
  hostDirectives: [
    { directive: NgDiagramNodeSelectedDirective, inputs: ['node'] },
  ],
  templateUrl: './avsNode.html',
  styleUrls: ['./avsNode.scss'],
})
export class AvsNodeComponent implements NgDiagramNodeTemplate<CustomDataType> {
  node = input.required<Node<CustomDataType>>();

}